import { AutoComplete, Col, Form, Input, Row, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MONTHS } from "../../../../../constants/constants";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { ScenarioModel } from "../../../../../models/scenario.model";
import { AuthService } from "../../../../../services/auth.service";
import { ERMService } from "../../../../../services/erm.service";
import UTIL from "../../../../../utils/utils";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../atoms/icon";
import { AppChildrenSelect, AppSelect } from "../../../../atoms/select";

const { Option } = Select;

const PlaningSection = (props: FormSectionProps<ScenarioModel>) => {


    const { t } = useTranslation();

    const [approversOptions, setApproversOptions] = useState<{ value: string }[]>([]);
    const approvers = useRef<{ value: string }[]>([]);


    const onApproverSearch = (searchText: string | undefined) => {
        setApproversOptions(!searchText ? approvers.current : approvers.current.filter(x => x.value.includes(searchText)));
    };

    useEffect(() => {
        const user = AuthService.getUserInfo();

        ERMService.getApprovers().then(res => {
            const aprs = (res.data as any[]).filter(p => p.username !== user?.username).map(x => {
                return {
                    value: x.email
                }
            });
            approvers.current = aprs;
            setApproversOptions(aprs);
        })
    }, []);

    return (
        <div className="section-wrapper">

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbScenarioEventDesignerName")}
                        name="designer_name"
                        tooltip={{ title: t("Scenario.lbScenarioEventDesignerName"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("designer_name", props.requiredFields)}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={12}>

                    <AppSelect
                        className="lable-full-width"
                        label={t("Scenario.lbDesignerDivision")}
                        name="designer_division_id"
                        tooltip={{ title: t("Scenario.lbDesignerDivision"), icon: <InfoCircleIcon /> }}
                        placeholder={t("Scenario.plDivision")}
                        list={props.resources?.divisions}
                        rules={VALIDATION_UTIL.getRulesValidationField("designer_division_id", props.requiredFields)} />

                </Col>
                <Col span={12}>

                    <AppChildrenSelect
                        name="designer_business_unit_id"
                        parentName="designer_division_id"
                        list={props.resources?.business_units}
                        placeholder={t("Scenario.plBU")}
                        label="&nbsp;"
                        listFilterName="division_id"
                        rules={VALIDATION_UTIL.getRulesValidationField("designer_business_unit_id", props.requiredFields, undefined, " ")}
                    />

                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbEmail")}
                        name="email_information"
                        tooltip={{ title: t("Scenario.ttEmail"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("email_information", props.requiredFields, [{ type: "email" }])}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>

                    <Form.Item
                        label={t("ControlFailure.lbApprovalName")}
                        name="approval_name"
                        tooltip={{ title: t("ControlFailure.ttApprovalName"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("approval_name", props.requiredFields, [
                            { type: "email" },
                        ])}
                    >
                        <AutoComplete options={approversOptions} onSearch={onApproverSearch} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <Form.Item
                        className="lable-full-width"
                        label={t("Scenario.lbPlanningCycle")}
                        name="planing_cycle_month"
                        tooltip={{ title: t("Scenario.lbPlanningCycle"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("planing_cycle", props.requiredFields)}
                    >
                        <Select placeholder={t("Global.lbMonth")} >
                            {
                                MONTHS.map((item, index) => (
                                    <Option key={index} value={item.value}>{item.name}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="&nbsp;"
                        name="planing_cycle_year"
                        rules={VALIDATION_UTIL.getRulesValidationField("planing_cycle", props.requiredFields)}

                    >
                        <Select placeholder={t("Global.lbYear")} >
                            {
                                UTIL.planingCycleYears().map((item, index) => (
                                    <Option key={index} value={item}>{item}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default PlaningSection;